<template>
    <CustomButton 
        :to="{
            name: 'hiddenMasterProductByCompanyList', 
            params: { uuid: route.params.uuid }
        }" 
        label="Links.goBack" 
    />
    <p class="page-title pt-4">Cacher un produit pour une société cliente</p>
    <HideProduct/>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import CustomButton from "@/components/forms/CustomButton.vue";
import HideProduct from "@/components/product/masterProduct/hide/HideProduct.vue";

const route = useRoute();
</script>

<style scoped>
select {
background-color: pink;
}
</style>